<div class="message-list-ordered">
	<div class="text" *ngIf="elements.payload.text.length > 0">{{ elements.payload.text[0] }}</div>
	<ul>
		<li *ngFor="let item of elements.payload.values">{{ item }}</li>
	</ul>
</div>